export default __webpack_public_path__ + "static/media/note.545cc59a.png";